import { PanelList } from '../panel-list';
import type { BoardSetting } from './board-settings-client.type';

type BoardSettingsListProps = {
  boardSettings: BoardSetting[];
  selectedBoardSetting: BoardSetting | null;
  setSelectedBoardSettingId: (boardSettingId: string) => void;
  setIsEditing: (isEditing: boolean) => void;
  pageState: 'update' | 'create' | 'idle';
  setPageState: (pageState: 'update' | 'create' | 'idle') => void;
};

export function BoardSettingsList({
  boardSettings,
  selectedBoardSetting,
  setSelectedBoardSettingId,
  setIsEditing,
  pageState,
  setPageState,
}: BoardSettingsListProps) {
  const handleCreateClick = () => {
    setPageState('create');
  };

  return (
    <PanelList
      title="Board Settings"
      items={boardSettings || []}
      selectedItem={pageState === 'create' ? null : selectedBoardSetting}
      onSelect={(boardSetting) => {
        if (boardSetting.id) {
          setSelectedBoardSettingId(boardSetting.id);
          setIsEditing(false);
          setPageState('idle');
        }
      }}
      onAddNew={pageState === 'idle' ? handleCreateClick : undefined}
      isLoading={false}
      getItemId={(boardSetting) => boardSetting.id}
      getItemDisplayText={(boardSetting) => boardSetting.name}
    />
  );
}
